/**
 * Обновляет или удаляет информацию об изменении конкретного поля объекта.
 *
 * - Если новое значение отличается от старого, информация о разнице сохраняется в `changes[id]`.
 * - Если значения совпадают и изменение ранее было зафиксировано, оно удаляется.
 *
 * @param {Object} changes - Объект, содержащий все зафиксированные изменения.
 * @param {string} id - Идентификатор элемента, к которому относится изменение.
 * @param {string} fieldName - Имя изменённого поля (ключ объекта данных).
 * @param {*} oldValue - Предыдущее значение поля.
 * @param {*} newValue - Новое значение поля.
 * @param {string} railChainName - Название железнодорожной цепи (используется в `meta`).
 * @param {function} handleModify - Функция, вызываемая при изменении или удалении изменений.
 * @returns {boolean} Возвращает `true`, если изменение было зафиксировано, иначе `false`.
 */

export function trackChange(changes, id, fieldName, oldValue, newValue, railChainName, handleModify) {
  oldValue = oldValue === '' || oldValue === false ? null : oldValue;
  newValue = newValue === '' || newValue === false ? null : newValue;
  // Проверяем, что старое значение отличается от нового
  if (String(oldValue) !== String(newValue)) {
    if (!changes[id]) {
      changes[id] = {
        meta: {
          railChainName: railChainName,
        },
      }; // Если объекта с таким ID нет, создаем его
    }

    // Обновляем значение поля
    changes[id][fieldName] = {
      old: oldValue,
      new: newValue ? newValue : null,
    };
    handleModify(id);
    return true;
  } else {
    // Если старое значение равно новому, удаляем запись об изменении

    if (changes[id] && changes[id][fieldName]) {
      delete changes[id][fieldName];
      // если больше нет изменений кроме meta — удаляем всё
      const remainingKeys = Object.keys(changes[id]).filter((k) => k !== 'meta');
      if (remainingKeys.length === 0) {
        delete changes[id];
      }
    }
    handleModify(id, true);
    return false;
  }
}
